var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c('div', {
    staticClass: "popHowWorks",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "popHowWorks-main",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "popHowWorks__title"
  }, [_vm._v(_vm._s(_vm.$lang("HOW IT WORKS?")))]), _c('div', {
    staticClass: "popHowWorks__sub"
  }, [_vm._v("Based is a launchpad for memecoins on the " + _vm._s(_vm.web3Wallet.symbol) + " networks, designed to minimize rug-pull risks and promote fair token launches.")]), _c('div', {
    staticClass: "popHowWorks_img"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/ui/howWork.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popHowWorks-btn let",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Let's Based!")]), _c('div', {
    staticClass: "popHowWorks-get"
  }, [_c('div', {
    staticClass: "popHowWorks-get-main"
  }, [_c('div', {
    staticClass: "popHowWorks-get__intro"
  }, [_vm._v("Get the most from Fair Curve — our innovative community-driven model. You govern your token as a DAO member and get community incentives")]), _c('div', {
    staticClass: "popHowWorks-btn",
    on: {
      "click": _vm.onSkip
    }
  }, [_vm._v("Launch Token")])])])])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };